import client from './_client';

export async function getRolesList() {
  const { data } = await client.get('/roles');

  return data;
}